import React from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import { appName, currentYear } from '../common/helpers';
import PageMetaData from '../common/components/pageMetaData/PageMetaData';
import HorizontalLogo from '../common/components/logo/HorizontalLogo';

function ConfirmForgotPasswordLayout() {
  return (
    <div className="auth-box overflow-hidden align-items-center d-flex">
      <PageMetaData title="Confirm Forgot Password" />
      <Container>
        <Row className="justify-content-center">
          <Col xxl={4} md={6} sm={8}>
            <div className="auth-brand text-center mb-4">
              <HorizontalLogo />
            </div>

            <Card className="p-4 rounded-4">
              <h3 className="mt-3 text-center">Reset password confirmation</h3>
              <p className="mt-3 text-muted mx-auto w-lg-75 text-center">
                A message with further instructions has been sent to your email address.
              </p>
            </Card>

            <p className="text-center text-muted mt-4 mb-0">
              © {currentYear} <span className="fw-semibold">{appName}</span>
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default ConfirmForgotPasswordLayout;
